module.exports = __webpack_public_path__ + "static/img/team.c0a5083.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/common/team.png
// module id = nl7e
// module chunks = 1